var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPenToSquare = function SvgPenToSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m330 137.9 44.1 44.1-140.4 140.4-50.4 6.3 6.3-50.4zm95 61.1 17-17 36.1-36.1L512 112l-33.9-33.9-44.2-44.2L400 0l-33.9 33.9L330 70l-17 17-17 17-152 152-9.9 78.9L128 384l49.1-6.1L256 368l152-152zm-17-50.9L363.9 104 400 67.9l44.1 44.1zM24 64H0v448h448V288h-48v176H48V112h176V64H24"
  })));
};
export default SvgPenToSquare;